import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/reimpresiones',
  alias: ['/sistema/reportesbi/reimpresiones/Index'],
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['124'],
  cita: 'Areas/ReportesBI/Controllers/ReimpresionesController.cs:33',
} satisfies RutaProd;
